import css from "styled-jsx/css";

export const componentStyles = css`
  .product-tab-content{
    width: 100%;
  }
`;
